import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";

import { withCors } from "~/config/cors";
import { pageMeta } from "~/utils/meta";
import { PrivacyPage } from "~/pages/privacy";

export const meta = pageMeta(
    "Privacy Policy - IFS Companion",
    "IFS Companion Privacy Policy",
);

export const loader: LoaderFunction = withCors(async ({ request }) => json({}));

export default function PrivacyRoute() {
    return <PrivacyPage />;
}
